module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/shared-ownership-c1620df01a661155f03eca8046928d13.png";